export default "__VITE_ASSET__C1b2RIOk__"